export enum ContentKind {
  CODE = "CODE",
  OBJECT = "OBJECT",
  PLACEHOLDER = "PLACEHOLDER",
  PLAIN_TEXT = "PLAIN_TEXT",
}
